import { Injectable } from '@angular/core';
import { CustomAjax } from '../AjaxHelper';
import { AdministrationCheckout, Appointment, AppointmentHistory, MeetingAppointment } from '../AllTableClasses';

@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  constructor(private ajax: CustomAjax) { }

  public ResourcesGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/ResourcesGet", "", (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public ResourcesGetByBranchID(BranchID: number,fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/ResourcesGetByBranchID", `BranchID=${BranchID}`, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public ServiceAreasGetByBranchID(BranchID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/ServiceAreasGetByBranchID", `BranchID=${BranchID}`, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public EventsGet(BranchID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/EventsGet", `BranchID=${BranchID}`, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public AppointmentsGet(SelectedDate: string, BranchID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/AppointmentsGet", `SelectedDate=${SelectedDate}&BranchID=${BranchID}`, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public RolesGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/RolesGet", "", (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public BranchesGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/BranchesGet", "", (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public AppointmentTypeGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/AppointmentTypeGet", "", (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public PatientGetByIDNumber(IDNumber: string, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/PatientGetByIDNumber", `IDNumber=${IDNumber}`, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public PatientGetByCellphone(cellphone: string, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/PatientGetByCellphone", `cellphone=${cellphone}`, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public MemberGetBySurname(surname: string, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/MemberGetBySurname", `surname=${surname}`, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public UsersGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/UsersGet", "", (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public StaffGetByBranchID(BranchID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/StaffGetByBranchID", `BranchID=${BranchID}`, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public UsersGetByProvinceID(ProvinceID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/UsersGetByProvinceID", `ProvinceID=${ProvinceID}`, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public AppointmentSet(Appointment: Appointment, BranchID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/scheduler/AppointmentSet", { Appointment: Appointment, BranchID: BranchID }, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public AppointmentSummaryGetByID(AppointmentID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/scheduler/AppointmentSummaryGetByID", `AppointmentID=${AppointmentID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public AppointmentHistoryGet(AppointmentID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/scheduler/AppointmentHistoryGet", `AppointmentID=${AppointmentID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public AdministrationCheckoutGetByAppointmentID(AppointmentID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/scheduler/AdministrationCheckoutGetByAppointmentID", `AppointmentID=${AppointmentID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public AppointmentStatusSet(checkout: AdministrationCheckout, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/scheduler/AppointmentStatusSet", checkout,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public AdministrationCheckoutSet(checkout: AdministrationCheckout, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/scheduler/AdministrationCheckoutSet", checkout,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public AudiologistCheckoutGetByAppointmentID(AppointmentID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/scheduler/AudiologistCheckoutGetByAppointmentID", `AppointmentID=${AppointmentID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public AudiologistCheckoutSet(checkout: AdministrationCheckout, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/scheduler/AudiologistCheckoutSet", checkout,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public BranchGetByProvinceID(ProvinceID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/BranchGetByProvinceID", `ProvinceID=${ProvinceID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public UsersGetByBranchID(BranchID: number, RolesID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/UsersGetByBranchID", `BranchID=${BranchID}&RolesID=${RolesID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ProvinceGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/ProvinceGet", "",
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public EmployeeMeetingSet(meetingAppointments: Array<MeetingAppointment>, agentID: number, BranchID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/scheduler/EmployeeMeetingSet", { meetingAppointments: meetingAppointments, agentID: agentID, BranchID: BranchID},
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public HasArrivedSet(appointmentID: number, hasArrived: boolean, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/scheduler/HasArrivedSet", { appointmentID: appointmentID, hasArrived: hasArrived },
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public AppointmentHistorySet(appointmentHistory: AppointmentHistory, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/scheduler/AppointmentHistorySet", appointmentHistory,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public AppointmentsGetByUserID(UserID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/scheduler/AppointmentsGetByUserID", `UserID=${UserID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
}
